import { Switch, SwitchProps } from '@mui/material';
import { styled } from '@mui/material/styles';

interface ColoredSwitchProps extends SwitchProps {
  checkedColor?: string;
  uncheckedColor?: string;
}

const ColoredSwitch = styled(({ checkedColor, uncheckedColor, ...props }: ColoredSwitchProps) => (
  <Switch {...props} />
))(({ theme, checkedColor, uncheckedColor }) => {
  const defaultCheckedColor = theme.palette.mode === 'dark' ? '#089981' : '#089981';
  const defaultUncheckedColor = theme.palette.mode === 'dark' ? 'grey' : 'lightgrey';

  return {
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: checkedColor || defaultCheckedColor,
      '&:hover': {
        backgroundColor: `${(checkedColor || defaultCheckedColor)}33`, // 20% opacity
      },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: checkedColor || defaultCheckedColor,
    },
    '& .MuiSwitch-switchBase': {
      color: uncheckedColor || defaultUncheckedColor,
      '&:hover': {
        backgroundColor: `${(uncheckedColor || defaultUncheckedColor)}33`, // 20% opacity
      },
    },
    '& .MuiSwitch-track': {
      backgroundColor: uncheckedColor || defaultUncheckedColor,
    },
  };
});

export default ColoredSwitch;